import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import classNames from "classnames";
import utils from "@utils";
import { AssignmentRulesService } from "@services";
import {
	AUTO_APPROVAL_TYPES,
	DAYS_OF_WEEK,
	ORDER_OF_SENIORITY,
	HOLYOKEPD_MA_COORDINATOR,
} from "@constants";

import { ReactSelect, ConfirmationModal, Modal, Tooltip, TimeInput } from "../../../../components";

import "./AssignmentRulesModal.scss";

class AssignmentRulesModal extends Component {
	constructor(props) {
		super(props);
		const { userData } = this.props;
		this.isHolyokeOrg = HOLYOKEPD_MA_COORDINATOR.includes(userData?.Organization.Id);
		this.timesToPost = [
			{ label: "Now", value: "immediately" },
			{ label: "Based on job time", value: "basedOnJob" },
			{ label: "Specific date/time", value: "specificDate" },
		];
		this.signUpPeriodTimeTypeOptions = [
			{ label: "hours", value: 1 },
			{ label: "days", value: 24 },
		];
		const {
			FIRST_COME_FIRST_SERVED,
			MANUAL,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			BY_HOURS,
			BY_JOBS,
			RANDOM,
			SENIORITY_DRAFT,
		} = AUTO_APPROVAL_TYPES;
		this.assignmentTypes = [
			{ label: "Manually", value: MANUAL },
			{ label: "First come first serve", value: FIRST_COME_FIRST_SERVED },
			{ label: "By hours", value: BY_HOURS },
			{ label: "By number of jobs", value: BY_JOBS },
			{ label: "Most senior", value: SENIORITY_DESCENDING },
			{ label: "Least senior", value: SENIORITY_ASCENDING },
			{ label: "Seniority draft", value: SENIORITY_DRAFT },
			{ label: "Randomly ", value: RANDOM },
		];
		this.state = this.getInitialState();
		this._confirmationModal = React.createRef();
	}

	/** create a clone of initial state in order to prevent manipulating its refrence */
	getInitialState = () => ({
		signUpPeriodHoursMultiplier: 1,
		timeToPost: "immediately",
		postAt: "PostPriorByDays",
		postingTime: utils.isDesktopSafari || utils.isIE ? "12:00 AM" : "00:00",
		daysPriorForWeek: "",
		monthDayTime: utils.isDesktopSafari || utils.isIE ? "12:00 AM" : "00:00",
		PostedType: 0,
		PostedDelayType: "",
		PostDelayInMinutes: "",
		PostedGroup: -2,
		OpenToAllOfficers: false,
		PostPriorByDays: "",
		EnableFirstComeFirstServed: false,
		weekDayTime: utils.isDesktopSafari || utils.isIE ? "12:00 AM" : "00:00",
		PostByWeekDay: "",
		PostByMonthDay: "",
		JobAutoAssignType: 1,
		JobAutoAssignRolling365: false,
		JobAssignmentBiAnnually: false,
		OnlyCountHoursForJobsPostedWithThisRule: false,
		JobAutoAssignHoursSpan: "",
		SeniorityOrder: null,
		_hoursJobsSelectedOption: "MaxHoursAssignmentPerCycle",
		NumberOfRounds: "",
		_limitToRoundsChecked: false,
		JobAutoAssignYearToDateSpan: true,
		JobAutoAssignJobCountDaysSpan: "",
		assignmentGroups: [],
		assignmentRuleName: "",
		fcfsAssignmentOption: 0,
		AssignmentGroupType: 0,
		AutoAssignCycleLimits: [
			{
				CycleMaxAssignments: "",
				CycleDaysSpan: "",
				id: 1,
			},
		],
		JobAutoAssignQueueCycleMaxAssignments: "",
		JobAutoAssignJobCountDaysRadio: false,
		MaxHoursAssignmentPerCycle: "",
		_hoursJobsSelectedOptionValue: "",
		PostExactDateTime: "",
		postExactTime: utils.isDesktopSafari || utils.isIE ? "12:00 AM" : "00:00",
		errors: {
			assignmentRuleName: false,
			PostedGroup: false,
			PostDelayInMinutes: false,
			postingTime: false,
			PostPriorByDays: false,
			PostByWeekDay: false,
			weekDayTime: false,
			daysPriorForWeek: false,
			PostByMonthDay: false,
			monthDayTime: false,
			JobAutoAssignHoursSpan: false,
			SeniorityOrder: false,
			JobAutoAssignJobCountDaysSpan: false,
			CycleMaxAssignments: false,
			CycleDaysSpan: false,
			JobAutoAssignQueueCycleMaxAssignments: false,
			MaxHoursAssignmentPerCycle: false,
			PostExactDateTime: false,
			postExactTime: false,
			_hoursJobsSelectedOptionValue: false,
			NumberOfRounds: false,
		},
	});

	componentDidUpdate(prevProps) {
		const { show, assignmentRuleId } = this.props;
		if (prevProps.show !== show && show && assignmentRuleId !== null) {
			this.loadAssignmentGroup();
		}
	}

	//  Service Methods

	/** Gathers all assignment rules data retrevied from the service call */
	loadAssignmentGroup = () => {
		const { lang } = global;
		const { assignmentRuleId } = this.props;
		const { SENIORITY_DRAFT } = AUTO_APPROVAL_TYPES;

		AssignmentRulesService.getById(assignmentRuleId)
			.then(({ data }) => {
				let postAt = "PostPriorByDays";
				let postingTime = "";
				let weekDayTime = "";
				let daysPriorForWeek = "";
				let PostExactDateTime = "";
				let postExactTime = "";
				let monthDayTime = "";
				let PostPriorByDays = "";
				let PostByWeekDay = "";
				let PostByMonthDay = "";
				let signUpPeriodHoursMultiplier = 1;
				let JobAutoAssignHoursSpan = "";
				let fcfsAssignmentOption = 0;
				let hours = Math.floor(data.PostTimeInMinutes / 60);
				let minutes = data.PostTimeInMinutes % 60;
				hours = hours < 10 ? `0${hours}` : hours;
				minutes = minutes < 10 ? `0${minutes}` : minutes;
				const time =
					utils.isDesktopSafari || utils.isIE
						? `${hours}:${minutes} ${hours > 12 ? "PM" : "AM"}`
						: `${hours}:${minutes}`;
				let auxTimeToPost = "immediately";
				if (data.PostPriorByDays && data.PostByWeekDay === null) {
					postAt = "PostPriorByDays";
					PostPriorByDays = data.PostPriorByDays;
					postingTime = time;
					auxTimeToPost = "basedOnJob";
				} else if (data.PostByWeekDay !== null) {
					postAt = "PostByWeekDay";
					PostByWeekDay = data.PostByWeekDay;
					daysPriorForWeek = data.PostPriorByDays;
					weekDayTime = time;
					auxTimeToPost = "basedOnJob";
				} else if (data.PostByMonthDay !== null) {
					postAt = "PostByMonthDay";
					PostByMonthDay = data.PostByMonthDay;
					monthDayTime = time;
					auxTimeToPost = "basedOnJob";
				} else if (data.PostExactDateTime !== null) {
					postAt = "PostExactDateTime";
					const [date, postExactTimeData] = data.PostExactDateTime.split("T");
					PostExactDateTime = date;
					postExactTime = postExactTimeData;
					auxTimeToPost = "specificDate";
				}

				if (data.JobAutoAssignHoursSpan && data.JobAutoAssignHoursSpan % 24 === 0) {
					signUpPeriodHoursMultiplier = 24;
					JobAutoAssignHoursSpan = (data.JobAutoAssignHoursSpan / 24).toString();
				} else {
					JobAutoAssignHoursSpan = data.JobAutoAssignHoursSpan || "";
				}

				if (data.AssignmentGroupType === 1) {
					fcfsAssignmentOption = 2;
				} else if (data.AssignmentGroupType === 2) {
					fcfsAssignmentOption = 1;
				}
				let auxPostedGroup = "";
				if (data.PostedType === 0) {
					auxPostedGroup = -2;
				} else if (data.PostedType === 1) {
					auxPostedGroup = -1;
				} else {
					auxPostedGroup = data.PostedGroup;
				}

				this.setState({
					JobAutoAssignJobCountDaysSpan: data.JobAutoAssignJobCountDaysSpan || "",
					JobAutoAssignJobCountDaysRadio:
						!data.JobAutoAssignRolling365 && !data.JobAutoAssignYearToDateSpan,
					JobAutoAssignType: data.JobAutoAssignType || "",
					JobAutoAssignYearToDateSpan: data.JobAutoAssignYearToDateSpan || "",
					JobAutoAssignRolling365: data.JobAutoAssignRolling365 || "",
					JobAssignmentBiAnnually: data.JobAssignmentBiAnnually || "",
					OnlyCountHoursForJobsPostedWithThisRule:
						data.OnlyCountHoursForJobsPostedWithThisRule || "",
					assignmentRuleName: data.Name || "",
					OpenToAllOfficers: data.PostedDelayType !== 0,
					PostedDelayType: data.PostedDelayType,
					PostDelayInMinutes: data.PostDelayInMinutes
						? (data.PostDelayInMinutes / 60).toString()
						: "",
					PostedGroup: auxPostedGroup,
					PostedType: data.PostedType || 0,
					SeniorityOrder: data.SeniorityOrder,
					EnableFirstComeFirstServed: data.KeepOriginalBehaviorForAutoAssign,
					NumberOfRounds: data.NumberOfRounds || "",
					_limitToRoundsChecked: !!data.NumberOfRounds,
					timeToPost: auxTimeToPost,
					AssignmentGroupType: data.AssignmentGroupType || 0,
					JobAutoAssignQueueCycleMaxAssignments:
						data.JobAutoAssignQueueCycleMaxAssignments,
					// eslint-disable-next-line max-len
					_hoursJobsSelectedOptionValue:
						data.JobAutoAssignType === SENIORITY_DRAFT
							? data.MaxHoursAssignmentPerCycle ||
								data.JobAutoAssignQueueCycleMaxAssignments
							: null,
					// eslint-disable-next-line max-len
					_hoursJobsSelectedOption:
						data.MaxHoursAssignmentPerCycle !== null
							? "MaxHoursAssignmentPerCycle"
							: "JobAutoAssignQueueCycleMaxAssignments",
					AutoAssignCycleLimits: data.AutoAssignCycleLimits
						? data.AutoAssignCycleLimits.map((item, i) => ({ ...item, id: i }))
						: [{ CycleMaxAssignments: "", CycleDaysSpan: "", id: 1 }],
					signUpPeriodHoursMultiplier,
					JobAutoAssignHoursSpan,
					PostByMonthDay,
					PostByWeekDay,
					PostPriorByDays,
					daysPriorForWeek,
					postAt,
					postingTime,
					weekDayTime,
					monthDayTime,
					fcfsAssignmentOption,
					PostExactDateTime,
					postExactTime,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading Assignment Rule"),
					title: "Error",
				});
			});
	};

	/** Combine date and time into a string to be sent to the API */
	formatDateTime = (date, time) => {
		const formattedDate = utils.isIOSDevice
			? date.replace(/-/gi, "/")
			: utils.fixIELocaleString(date);
		let dateTime = "";
		if (time.includes(":")) {
			dateTime = `${formattedDate}T${time}`;
		} else {
			dateTime = `${formattedDate}T${time}:00.000`;
		}
		return dateTime;
	};

	validateSavingRules = message => {
		if (message.includes("a staggered assignment") || message.includes("a staggered ruleset")) {
			return true;
		}
		return false;
	};

	/**
	 *  Gathers any changes made to the assignent rules and makes a service call to save the assignment rule
	 * @param {Boolean} updateOnConflict Determiens if the assigment rule can bypass rule conflicts
	 */
	onSaveAssigmentRule = (updateOnConflict = false) => {
		const { lang } = global;
		const {
			JobAutoAssignQueueCycleMaxAssignments,
			JobAutoAssignHoursSpan,
			SeniorityOrder,
			_hoursJobsSelectedOption,
			_limitToRoundsChecked,
			NumberOfRounds,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignType,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignRolling365,
			JobAssignmentBiAnnually,
			OnlyCountHoursForJobsPostedWithThisRule,
			JobAutoAssignJobCountDaysRadio,
			PostedDelayType,
			PostedGroup,
			PostedType,
			AutoAssignCycleLimits,
			assignmentRuleName,
			AssignmentGroupType,
			fcfsAssignmentOption,
			PostPriorByDays,
			PostByWeekDay,
			PostByMonthDay,
			EnableFirstComeFirstServed,
			postAt,
			daysPriorForWeek,
			timeToPost,
			PostDelayInMinutes,
			postingTime,
			weekDayTime,
			monthDayTime,
			signUpPeriodHoursMultiplier,
			PostExactDateTime,
			postExactTime,
			_hoursJobsSelectedOptionValue,
		} = this.state;
		const { assignmentRuleId, successCallback } = this.props;
		// switch between creating and updating an Assignmnet Rule if an ID has been passed to the modal
		const createOrUpdate = assignmentRuleId ? "update" : "create";
		const { SENIORITY_DRAFT, MANUAL, BY_HOURS, BY_JOBS } = AUTO_APPROVAL_TYPES;
		let dataParams = {
			Name: assignmentRuleName,
			AutoAssignCycleLimits:
				fcfsAssignmentOption === 1
					? AutoAssignCycleLimits.map(({ id, ...limits }) => limits)
					: "",
			KeepOriginalBehaviorForAutoAssign:
				EnableFirstComeFirstServed && JobAutoAssignType !== MANUAL,
			PostPriorByDays,
			AssignmentGroupType,
			JobAutoAssignHoursSpan,
			SeniorityOrder,
			JobAutoAssignJobCountDaysSpan: JobAutoAssignJobCountDaysRadio
				? JobAutoAssignJobCountDaysSpan
				: "",
			JobAutoAssignType,
			JobAutoAssignYearToDateSpan:
				JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS
					? JobAutoAssignYearToDateSpan
					: false,
			JobAutoAssignRolling365:
				JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS
					? JobAutoAssignRolling365
					: false,
			JobAssignmentBiAnnually:
				JobAutoAssignType === BY_HOURS ? JobAssignmentBiAnnually : false,
			OnlyCountHoursForJobsPostedWithThisRule:
				JobAutoAssignType === BY_HOURS ? OnlyCountHoursForJobsPostedWithThisRule : false,
			PostedDelayType,
			PostedGroup: PostedType === 2 ? PostedGroup : null,
			PostedType,
			PostByWeekDay,
			PostByMonthDay,
			NumberOfRounds,
			JobAutoAssignQueueCycleMaxAssignments,
			PostExactDateTime:
				PostExactDateTime === ""
					? ""
					: this.formatDateTime(PostExactDateTime, postExactTime),
		};
		if (PostedDelayType === 1)
			dataParams.PostDelayInMinutes = parseInt(PostDelayInMinutes, 10) * 60;
		if (timeToPost === "basedOnJob") {
			switch (postAt) {
				case "PostPriorByDays":
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(postingTime);
					dataParams.PostPriorByDays = parseInt(PostPriorByDays, 10);
					break;
				case "PostByWeekDay":
					dataParams.PostByWeekDay = parseInt(PostByWeekDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(weekDayTime);
					dataParams.PostPriorByDays = parseInt(daysPriorForWeek, 10);
					break;
				case "PostByMonthDay":
					dataParams.PostByMonthDay = parseInt(PostByMonthDay, 10);
					dataParams.PostTimeInMinutes = utils.convertTimeToMinutes(monthDayTime);
					break;
				default:
					break;
			}
		}
		// if the sign up period is in days, calculate the equivalent hours
		if (parseInt(signUpPeriodHoursMultiplier, 10) === 24) {
			dataParams.JobAutoAssignHoursSpan = JobAutoAssignHoursSpan * 24;
		}
		if (JobAutoAssignType === SENIORITY_DRAFT) {
			if (SeniorityOrder) {
				dataParams.SeniorityOrder = SeniorityOrder;
			} else {
				dataParams.SeniorityOrder = 1;
			}
		}
		if (_hoursJobsSelectedOption && _hoursJobsSelectedOptionValue) {
			switch (_hoursJobsSelectedOption) {
				case "JobAutoAssignQueueCycleMaxAssignments":
					dataParams.JobAutoAssignQueueCycleMaxAssignments = parseInt(
						_hoursJobsSelectedOptionValue,
						10,
					);
					dataParams.MaxHoursAssignmentPerCycle = null;
					break;
				case "MaxHoursAssignmentPerCycle":
					dataParams.MaxHoursAssignmentPerCycle = parseInt(
						_hoursJobsSelectedOptionValue,
						10,
					);
					dataParams.JobAutoAssignQueueCycleMaxAssignments = null;
					break;
				default:
					break;
			}
		}

		if (_limitToRoundsChecked && NumberOfRounds) {
			dataParams.NumberOfRounds = parseInt(NumberOfRounds, 10);
		}

		if (assignmentRuleId) dataParams = { ...dataParams, Id: assignmentRuleId };
		const validation = this.validateForm();
		// check if form fields are valid before making request
		if (validation.isValid) {
			AssignmentRulesService[createOrUpdate]({ updateOnConflict }, { ...dataParams })
				.then(() => {
					utils.notify({
						type: "success",
						message:
							createOrUpdate === "update"
								? lang.t("Assignment rule updated successfully")
								: lang.t("Assignment rule created successfully"),
					});
					this.closeModal();
					successCallback();
				})
				.catch(error => {
					const {
						response: { data, status },
					} = error;

					if (status === 409) {
						if (this.validateSavingRules(data.Message)) {
							this._confirmationModal.current.openModal({
								title: "Assignment Rules with jobs",
								message: data.Message,
								cancelButton: "Accept",
								hideConfirm: true,
								onConfirm: () => this.onSaveAssigmentRule(true),
							});
						} else {
							this._confirmationModal.current.openModal({
								title: "Assignment Rules with jobs",
								message: data.Message,
								hideConfirm: false,
								cancelButton: "Cancel",
								onConfirm: () => this.onSaveAssigmentRule(true),
							});
						}
					} else {
						utils.notify({
							type: "error",
							message: lang.t("Error creating Assignment Rule"),
							title: "Error",
						});
					}
				});
		}
	};
	//  Service Methods

	/**
	 * Handles all changes that occur when toggling different radio inputs
	 * @param {Event} e The HTML event to inspect for handling changes to radio inputs
	 */
	handleRadioChange = e => {
		const {
			target: { name, value, id },
		} = e;
		let newValue = value;
		if (name === "PostedType" && (parseInt(value, 10) === 0 || parseInt(value, 10) === 1)) {
			this.setState({
				PostedGroup: "",
				PostedDelayType: "",
				PostDelayInMinutes: "",
			});
		} else if (name === "PostedType" && parseInt(value, 10) === 2) {
			this.setState({ PostedDelayType: 0 });
		}
		if (
			name === "PostedDelayType" &&
			(parseInt(value, 10) === 0 || parseInt(value, 10) === 2)
		) {
			this.setState({ PostDelayInMinutes: "" });
		}
		if (name === "timeToPost" && value === "immediately") {
			this.setState({
				postAt: "",
				postingTime: "",
				PostPriorByDays: "",
				PostByWeekDay: "",
				weekDayTime: "",
				daysPriorForWeek: "",
				PostByMonthDay: "",
				monthDayTime: "",
				PostExactDateTime: "",
				postExactTime: "",
			});
		}
		if (name === "postAt" && value === "PostPriorByDays") {
			this.setState({
				PostByWeekDay: "",
				weekDayTime: "",
				daysPriorForWeek: "",
				PostByMonthDay: "",
				monthDayTime: "",
				PostExactDateTime: "",
				postExactTime: "",
			});
		}
		if (name === "postAt" && value === "PostByWeekDay") {
			this.setState({
				postingTime: "",
				PostPriorByDays: "",
				PostByMonthDay: "",
				monthDayTime: "",
				PostExactDateTime: "",
				postExactTime: "",
			});
		}
		if (name === "postAt" && value === "PostByMonthDay") {
			this.setState({
				PostByWeekDay: "",
				weekDayTime: "",
				daysPriorForWeek: "",
				postingTime: "",
				PostPriorByDays: "",
				PostExactDateTime: "",
				postExactTime: "",
			});
		}
		if (name === "JobAutoAssignType" && parseInt(value, 10) === 1) {
			this.setState({
				JobAutoAssignHoursSpan: "",
				signUpPeriodHoursMultiplier: 1,
				JobAutoAssignJobCountDaysSpan: "",
				JobAutoAssignYearToDateSpan: true,
				JobAutoAssignRolling365: false,
				JobAutoAssignJobCountDaysRadio: false,
			});
		}
		if (name === "JobAutoAssignType" && parseInt(value, 10) === 8) {
			this.setState({
				SeniorityOrder: 1,
			});
		} else {
			this.setState({
				JobAutoAssignHoursSpan: "",
				signUpPeriodHoursMultiplier: 1,
				SeniorityOrder: null,
				JobAutoAssignQueueCycleMaxAssignments: "",
				JobAutoAssignJobCountDaysSpan: "",
				NumberOfRounds: "",
				_limitToRoundsChecked: false,
				AutoAssignCycleLimits: [{ CycleMaxAssignments: "", CycleDaysSpan: "", id: 1 }],
				_hoursJobsSelectedOptionValue: null,
				_hoursJobsSelectedOption: "MaxHoursAssignmentPerCycle",
				errors: {
					NumberOfRounds: false,
					JobAutoAssignQueueCycleMaxAssignments: false,
					JobAutoAssignHoursSpan: false,
				},
			});
		}

		if (name === "JobAutoAssignType" && parseInt(value, 10) !== 2) {
			this.setState({ fcfsAssignmentOption: 0 });
		}

		if (name === "fcfsAssignmentOption" && parseInt(value, 10) === 1) {
			this.setState({ AssignmentGroupType: 2 });
		} else if (name === "fcfsAssignmentOption" && parseInt(value, 10) === 2) {
			this.setState({ AssignmentGroupType: 1 });
		} else {
			this.setState({
				AssignmentGroupType: 0,
				NumberOfRounds: "",
				_limitToRoundsChecked: false,
				errors: {
					NumberOfRounds: false,
				},
			});
		}

		if (
			name === "JobAutoAssignType" ||
			name === "PostedType" ||
			name === "PostedDelayType" ||
			name === "fcfsAssignmentOption"
		)
			newValue = parseInt(value, 10);

		if (name === "JobAutoAssignYearToDateSpan") newValue = value === "true";

		if (name === "JobAutoAssignYearToDateSpan") {
			const parsedId = id.substring(0, id.indexOf("-"));
			switch (parsedId) {
				case "JobAutoAssignRolling365":
					this.setState({
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: value === "true",
						JobAutoAssignJobCountDaysSpan: "",
						JobAutoAssignJobCountDaysRadio: false,
						JobAssignmentBiAnnually: false,
					});
					return;
				case "JobAutoAssignJobCountDaysRadio":
					this.setState({
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysSpan: "",
						JobAutoAssignJobCountDaysRadio: true,
						JobAssignmentBiAnnually: false,
					});
					return;
				case "JobAssignmentBiAnnually":
					this.setState({
						JobAutoAssignYearToDateSpan: false,
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysSpan: "",
						JobAutoAssignJobCountDaysRadio: false,
						JobAssignmentBiAnnually: value === "true",
					});
					return;
				default:
					this.setState({
						JobAutoAssignYearToDateSpan: value === "true",
						JobAutoAssignRolling365: false,
						JobAutoAssignJobCountDaysSpan: "",
						JobAutoAssignJobCountDaysRadio: false,
						JobAssignmentBiAnnually: false,
					});
					return;
			}
		}
		this.setState({ [name]: newValue });
	};

	/**
	 * Handles all changes that occur when changing form inputs
	 * @param {Event} e The HTML event to inspect for handling changes to inputs
	 * @param {String} property The property of the element being changed
	 */
	handleInputChange = (e, property) => {
		let value;
		let type;
		let name;
		let checked;
		if (
			property === "PostedGroup" ||
			property === "timeToPost" ||
			property === "JobAutoAssignType"
		) {
			value = e?.value || "";
			type = e?.type || "";
			name = e?.name || property;
			if (property === "PostedGroup") {
				let auxPostedType;
				if (value === -2) {
					auxPostedType = 0;
				} else if (value === -1) {
					auxPostedType = 1;
				} else {
					auxPostedType = 2;
				}
				this.setState({
					PostedType: auxPostedType,
					OpenToAllOfficers: false,
					PostedDelayType: null,
					PostDelayInMinutes: "",
				});
			}
			if (name === "timeToPost") {
				this.setState({
					postAt: "",
					postingTime: "",
					PostPriorByDays: "",
					PostByWeekDay: "",
					weekDayTime: "",
					daysPriorForWeek: "",
					PostByMonthDay: "",
					monthDayTime: "",
					PostExactDateTime: "",
					postExactTime: "",
				});
			}
			if (name === "JobAutoAssignType") {
				let auxSeniorityOrder = null;
				if (value === 5) {
					auxSeniorityOrder = 1;
				}
				if (value === 6) {
					auxSeniorityOrder = 2;
				}
				this.setState({
					JobAutoAssignHoursSpan: "",
					signUpPeriodHoursMultiplier: 1,
					SeniorityOrder: auxSeniorityOrder,
					JobAutoAssignQueueCycleMaxAssignments: "",
					JobAutoAssignJobCountDaysSpan: "",
					NumberOfRounds: "",
					_limitToRoundsChecked: false,
					AutoAssignCycleLimits: [{ CycleMaxAssignments: "", CycleDaysSpan: "", id: 1 }],
					_hoursJobsSelectedOptionValue: null,
					_hoursJobsSelectedOption: "MaxHoursAssignmentPerCycle",
					errors: {
						NumberOfRounds: false,
						JobAutoAssignQueueCycleMaxAssignments: false,
						JobAutoAssignHoursSpan: false,
					},
				});
			}
		} else {
			({
				target: { value, type, name, checked },
			} = e);
		}
		if (type === "tel") value = value.replace(/\D/g, "");

		if (type === "checkbox") {
			value = checked;
			if (property === "OpenToAllOfficers") {
				if (!checked) {
					this.setState({ PostedDelayType: 0 });
				}
			}
		}

		if (name === "_limitToRoundsChecked") {
			value = checked;

			if (!checked) {
				this.setState({
					NumberOfRounds: "",
					errors: {
						NumberOfRounds: false,
					},
				});
			}
		}

		this.setState({ [name]: value });
	};

	/**
	 * Handles all changes that occur when changing form inputs that are integer specific
	 * @param {Event} e The HTML event to inspect for handling blurring off integer inputs
	 */
	handleIntegerOnBlur = e => {
		const {
			target: { value, name },
		} = e;
		// OnBlur : set values to initial state if the value is less than 1
		if (name === "PostByMonthDay" && parseInt(value, 10) > 31) {
			this.setState({ PostByMonthDay: "31" });
		}
		if (parseInt(value, 10) < 1) this.setState({ [name]: "" });
	};

	/**
	 * Validates changes made to each input in the assignment rules modal
	 * @returns {Boolean} Determines if the changes made to each input are valid
	 */
	validateForm = () => {
		const {
			assignmentRuleName,
			timeToPost,
			PostedType,
			PostedDelayType,
			postAt,
			postingTime,
			PostPriorByDays,
			PostedGroup,
			PostDelayInMinutes,
			PostByWeekDay,
			weekDayTime,
			daysPriorForWeek,
			PostByMonthDay,
			monthDayTime,
			JobAutoAssignType,
			JobAutoAssignHoursSpan,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignRolling365,
			JobAssignmentBiAnnually,
			fcfsAssignmentOption,
			AutoAssignCycleLimits,
			JobAutoAssignQueueCycleMaxAssignments,
			errors,
			PostExactDateTime,
			postExactTime,
			_hoursJobsSelectedOptionValue,
			_limitToRoundsChecked,
			NumberOfRounds,
		} = this.state;
		let isValid = true;

		const {
			FIRST_COME_FIRST_SERVED,
			BY_HOURS,
			BY_JOBS,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			RANDOM,
			SENIORITY_DRAFT,
		} = AUTO_APPROVAL_TYPES;

		// Validate and ensure each field is not empty when toggled
		errors.assignmentRuleName = assignmentRuleName.trim() === "";

		if (PostedType === 2) {
			errors.PostedGroup = PostedGroup === "";
		}

		if (PostedDelayType === 1) {
			errors.PostDelayInMinutes = PostDelayInMinutes === "";
		}

		if (timeToPost === "basedOnJob" && postAt === "PostPriorByDays") {
			errors.postingTime = !this.isTimeValid(postingTime);
			errors.PostPriorByDays = PostPriorByDays === "" || PostPriorByDays === "0";
		} else if (timeToPost === "basedOnJob" && postAt === "PostByWeekDay") {
			errors.PostByWeekDay = PostByWeekDay === "";
			errors.weekDayTime = !this.isTimeValid(weekDayTime);
			errors.daysPriorForWeek = daysPriorForWeek === "" || daysPriorForWeek === "0";
		} else if (timeToPost === "basedOnJob" && postAt === "PostByMonthDay") {
			errors.PostByMonthDay = PostByMonthDay === "" || PostByMonthDay === "0";
			errors.monthDayTime = !this.isTimeValid(monthDayTime);
		} else if (timeToPost === "specificDate" && postAt === "PostExactDateTime") {
			errors.PostExactDateTime = !errors.PostExactDateTime
				? PostExactDateTime === "" || PostExactDateTime === "0"
				: true;
			errors.postExactTime = !errors.postExactTime ? !this.isTimeValid(postExactTime) : true;
		} else {
			errors.postingTime = false;
			errors.PostPriorByDays = false;
			errors.PostByWeekDay = false;
			errors.PostPriorByDays = false;
			errors.weekDayTime = false;
			errors.daysPriorForWeek = false;
			errors.PostByMonthDay = false;
			errors.monthDayTime = false;
			errors.postExactTime = false;
			errors.PostExactDateTime = false;
		}

		// Officer Approval & Assignment Rules - HOURS, JOBS, SENIORITY(ASC,DESC) validation
		if (
			[
				BY_HOURS,
				BY_JOBS,
				SENIORITY_DESCENDING,
				SENIORITY_ASCENDING,
				RANDOM,
				SENIORITY_DRAFT,
			].includes(JobAutoAssignType)
		) {
			errors.JobAutoAssignHoursSpan = utils.validateNumberInputRequired(
				JobAutoAssignHoursSpan,
				false,
			);
		} else {
			errors.JobAutoAssignHoursSpan = false;
		}
		if (
			(JobAutoAssignType === BY_HOURS || JobAutoAssignType === BY_JOBS) &&
			!JobAutoAssignYearToDateSpan &&
			!JobAutoAssignRolling365 &&
			!JobAssignmentBiAnnually
		) {
			errors.JobAutoAssignJobCountDaysSpan = JobAutoAssignJobCountDaysSpan === "";
		} else {
			errors.JobAutoAssignJobCountDaysSpan = false;
		}
		if (
			JobAutoAssignType === SENIORITY_DESCENDING ||
			JobAutoAssignType === SENIORITY_ASCENDING
		) {
			errors.JobAutoAssignQueueCycleMaxAssignments = !JobAutoAssignQueueCycleMaxAssignments;
		} else {
			errors.JobAutoAssignQueueCycleMaxAssignments = false;
		}

		if (
			[
				FIRST_COME_FIRST_SERVED,
				SENIORITY_DESCENDING,
				SENIORITY_ASCENDING,
				SENIORITY_DRAFT,
			].includes(JobAutoAssignType)
		) {
			if (_limitToRoundsChecked) {
				errors.NumberOfRounds = utils.validateNumberInputRequired(NumberOfRounds, false);
			} else {
				errors.NumberOfRounds = false;
			}
		}

		// Seniority draft validation
		if (JobAutoAssignType === SENIORITY_DRAFT) {
			// _hoursJobsSelectedOptionValue, JobAutoAssignHoursSpan
			errors._hoursJobsSelectedOptionValue = utils.validateNumberInputRequired(
				_hoursJobsSelectedOptionValue,
				false,
			);
			errors.JobAutoAssignHoursSpan = utils.validateNumberInputRequired(
				JobAutoAssignHoursSpan,
				false,
			);
		}

		// Officer Approval & Assignment Rules - FCFS validation
		if (JobAutoAssignType === 2) {
			if (fcfsAssignmentOption === 1) {
				const daySpanValidation = AutoAssignCycleLimits.every(
					item => item.CycleDaysSpan === "",
				);
				const assignmentsValidation = AutoAssignCycleLimits.every(
					item => item.CycleMaxAssignments === "",
				);
				errors.CycleDaysSpan = daySpanValidation;
				errors.CycleMaxAssignments = assignmentsValidation;
			} else {
				errors.CycleDaysSpan = false;
				errors.CycleMaxAssignments = false;
			}
			if (fcfsAssignmentOption === 2) {
				errors.JobAutoAssignHoursSpan = JobAutoAssignHoursSpan === "";
				errors.JobAutoAssignQueueCycleMaxAssignments =
					!JobAutoAssignQueueCycleMaxAssignments;
			} else {
				errors.JobAutoAssignHoursSpan = false;
				errors.JobAutoAssignQueueCycleMaxAssignments = false;
			}
		}

		this.setState({ errors });

		isValid = Object.values(errors).filter(error => error === true).length === 0;

		return { isValid };
	};

	/**
	 * Validates the time inputed by the user since time is handled differently in some browsers
	 * @param {String} time The time inputed by the user
	 * @returns {Boolean} Determines if the converted time is valid in each browser
	 */
	isTimeValid = time => {
		// If time is blank, it is not valid
		if (time === "") {
			return false;
		}
		let timeRegex = /(\d{2}):(\d{2})/;
		if (utils.isDesktopSafari || utils.isIE) {
			timeRegex = /(\d{2}):(\d{2}) (A|P)M/i;
		}
		return timeRegex.test(time);
	};

	closeModal = () => {
		const { closeModal } = this.props;
		this.setState(this.getInitialState());
		closeModal();
	};

	/**
	 * Handles all changes that occur when changing form inputs hspecific to fcfs job limits
	 * @param {Event} e The HTML event to inspect for handling changes to job limit inputs
	 * @param {Number} index The index of the job limit inut being changed
	 */
	handleJobLimitChange = (e, index) => {
		const {
			target: { value, name },
		} = e;
		const newValue = value.replace(/\D/g, "");
		this.setState(prevState => {
			const newLimit = [...prevState.AutoAssignCycleLimits];
			newLimit[index][name] = newValue;
			return { AutoAssignCycleLimits: newLimit };
		});
	};

	/**
	 * Adds or removes jobs limit inputs from the fcfs list
	 * @param {Number} id The unique id of the fcfs input list
	 */
	setJobLimits = id => {
		const { AutoAssignCycleLimits } = this.state;
		if (id || id === 0) {
			this.setState(prevState => ({
				AutoAssignCycleLimits: prevState.AutoAssignCycleLimits.filter(
					item => item.id !== id,
				),
			}));
		} else {
			this.setState(prevState => ({
				AutoAssignCycleLimits: [
					...prevState.AutoAssignCycleLimits,
					{
						CycleMaxAssignments: "",
						CycleDaysSpan: "",
						id: AutoAssignCycleLimits.length + 1,
					},
				],
			}));
		}
	};

	changeDate =
		property =>
		({ target: { value, min } }) => {
			const formattedValue = utils.isIOSDevice ? value.replace(/\//gi, "-") : value;
			const { userData } = this.props;
			if (property === "PostExactDateTime" && formattedValue !== "") {
				const { postExactTime, errors } = this.state;
				const minStartDate = utils.formatDate();
				let time = postExactTime;
				let errorObj = {
					errors: {
						...errors,
						postExactTime: false,
						PostExactDateTime: false,
					},
				};

				if (formattedValue < min) {
					errorObj = {
						errors: {
							PostExactDateTime: true,
						},
					};
				}

				if (formattedValue === minStartDate) {
					time = utils.formatTime(undefined, false, userData?.TimeZoneId);
				}

				this.setState(() => ({
					PostExactDateTime: formattedValue,
					postExactTime: time,
					...errorObj,
				}));

				return;
			}

			this.setState({ [property]: formattedValue });
		};

	render() {
		const { lang } = global;
		const {
			signUpPeriodHoursMultiplier,
			timeToPost,
			postAt,
			postingTime,
			daysPriorForWeek,
			monthDayTime,
			PostedType,
			PostedDelayType,
			PostDelayInMinutes,
			PostedGroup,
			PostPriorByDays,
			weekDayTime,
			PostByWeekDay,
			OpenToAllOfficers,
			PostByMonthDay,
			JobAutoAssignType,
			JobAutoAssignHoursSpan,
			SeniorityOrder,
			JobAutoAssignYearToDateSpan,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignRolling365,
			JobAssignmentBiAnnually,
			OnlyCountHoursForJobsPostedWithThisRule,
			JobAutoAssignJobCountDaysRadio,
			assignmentRuleName,
			fcfsAssignmentOption,
			AutoAssignCycleLimits,
			JobAutoAssignQueueCycleMaxAssignments,
			EnableFirstComeFirstServed,
			_hoursJobsSelectedOption,
			_limitToRoundsChecked,
			NumberOfRounds,
			errors,
			PostExactDateTime,
			postExactTime,
			_hoursJobsSelectedOptionValue,
		} = this.state;
		const { show, officerGroups, assignmentRuleId, userData } = this.props;
		const weekdays = DAYS_OF_WEEK.map(({ value, label }) => ({ value, label }));
		const {
			FIRST_COME_FIRST_SERVED,
			MANUAL,
			SENIORITY_DESCENDING,
			SENIORITY_ASCENDING,
			SENIORITY_DRAFT,
			BY_HOURS,
			BY_JOBS,
			RANDOM,
		} = AUTO_APPROVAL_TYPES;

		const { MOST_SENIOR, LEAST_SENIOR } = ORDER_OF_SENIORITY;

		const minStartDate = utils.formatDate();
		const now = utils.formatTime(undefined, false, userData?.TimeZoneId);
		const minTime = PostExactDateTime === minStartDate ? now : undefined;
		const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];

		return (
			<Fragment>
				<Modal
					show={show}
					onHide={() => this.closeModal()}
					id="assignment-rules-modal"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{`${lang.t(assignmentRuleId ? "Edit" : "Create")} ${lang.t("Assignment Rules")}`}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{/* Assignment Rule Name */}
						<div className="row">
							<br />
							<div className="col-xs-12">{lang.t("Assignment Rule Name")}</div>
							<div className="col-xs-12 col-sm-7">
								<input
									className={classNames("form-control", {
										"has-error": errors.assignmentRuleName,
									})}
									name="assignmentRuleName"
									value={assignmentRuleName}
									onChange={e => this.handleInputChange(e)}
								/>
							</div>
						</div>
						{/* Assignment Rule Name */}

						<div className="separator separator-solid" />

						<div className="row">
							<div
								className="col-xs-12"
								style={{ marginTop: "5px" }}
							>
								<div
									className={classNames("form-group", {
										"has-error": errors.AssignmentGroupId,
									})}
								>
									<span>{lang.t("Post Time")}</span>
									<ReactSelect
										options={this.timesToPost}
										name="timeToPost"
										value={timeToPost}
										onChange={e => this.handleInputChange(e, "timeToPost")}
									/>
								</div>
							</div>
							<div className="col-xs-12">
								<If condition={timeToPost === "basedOnJob"}>
									<div className="indent">
										<div className="radio radio-align">
											<label htmlFor="PostPriorByDays">
												<input
													type="radio"
													name="postAt"
													id="PostPriorByDays"
													value="PostPriorByDays"
													checked={postAt === "PostPriorByDays"}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Daily:")}
											</label>
										</div>
										<TimeInput
											name="postingTime"
											id="postingTime"
											time={postingTime}
											className={classNames("form-control", {
												"has-error": errors.postingTime,
											})}
											disabled={postAt !== "PostPriorByDays"}
											handleChange={e => this.handleInputChange(e)}
											user={userData}
										/>
										<input
											type="tel"
											className={classNames("form-control", {
												"has-error": errors.PostPriorByDays,
											})}
											placeholder="eg: 2"
											name="PostPriorByDays"
											value={PostPriorByDays}
											disabled={postAt !== "PostPriorByDays"}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<span>{lang.t("days prior to the job start_")}</span>
									</div>

									<div className="indent">
										<div className="radio radio-align">
											<label htmlFor="PostByWeek">
												<input
													type="radio"
													name="postAt"
													id="PostByWeek"
													value="PostByWeekDay"
													checked={postAt === "PostByWeekDay"}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Weekly:")}
											</label>
										</div>
										<select
											placeholder={lang.t("Select day")}
											className={classNames("form-control", {
												"has-error": errors.PostByWeekDay,
											})}
											name="PostByWeekDay"
											value={PostByWeekDay}
											disabled={postAt !== "PostByWeekDay"}
											onChange={e => this.handleInputChange(e)}
										>
											<option value="">{lang.t("Select a week day")}</option>
											<For
												each="item"
												of={weekdays}
												index="index"
											>
												<option
													key={`PostByWeekDay_days${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
										<span>{lang.t("At")}</span>
										<TimeInput
											name="weekDayTime"
											id="weekDayTime"
											time={weekDayTime}
											className={classNames("form-control", {
												"has-error": errors.weekDayTime,
											})}
											disabled={postAt !== "PostByWeekDay"}
											handleChange={e => this.handleInputChange(e)}
											user={userData}
										/>
										<input
											className={classNames("form-control", {
												"has-error": errors.daysPriorForWeek,
											})}
											type="tel"
											placeholder="eg: 2"
											name="daysPriorForWeek"
											value={daysPriorForWeek}
											disabled={postAt !== "PostByWeekDay"}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<span>{lang.t("days prior to the job start_")}</span>
									</div>

									<div className="indent">
										<div className="radio radio-align">
											<label htmlFor="PostByMonth">
												<input
													type="radio"
													name="postAt"
													id="PostByMonth"
													value="PostByMonthDay"
													checked={postAt === "PostByMonthDay"}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Monthly:")}
											</label>
										</div>
										<input
											name="PostByMonthDay"
											id="PostByMonthDay"
											className={classNames("form-control", {
												"has-error": errors.PostByMonthDay,
											})}
											type="tel"
											value={PostByMonthDay}
											disabled={postAt !== "PostByMonthDay"}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<span>{lang.t("day of month at")}</span>
										<TimeInput
											name="monthDayTime"
											id="monthDayTime"
											time={monthDayTime}
											className={classNames("form-control", {
												"has-error": errors.monthDayTime,
											})}
											disabled={postAt !== "PostByMonthDay"}
											handleChange={e => this.handleInputChange(e)}
											user={userData}
										/>
										<span>{lang.t("all of next month jobs_")}</span>
									</div>
								</If>
								<If condition={timeToPost === "specificDate"}>
									<div
										className="indent date-select-container"
										title=""
									>
										<div className="radio radio-align">
											<label htmlFor="PostExactDateTime">
												<input
													type="radio"
													name="postAt"
													id="PostExactDateTime"
													value="PostExactDateTime"
													checked={postAt === "PostExactDateTime"}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Post on")}
											</label>
										</div>
										<Choose>
											<When condition={utils.isDesktopSafari || utils.isIE}>
												<MaskedInput
													name="PostExactDateTime"
													type="text"
													mask={dateMask}
													className={classNames(
														"form-control",
														"date-select",
														{
															"has-error": errors.PostExactDateTime,
														},
													)}
													placeholder="mm/dd/yyyy"
													min={minStartDate}
													value={PostExactDateTime}
													disabled={postAt !== "PostExactDateTime"}
													onChange={this.changeDate("PostExactDateTime")}
												/>
											</When>
											<Otherwise>
												<input
													name="PostExactDateTime"
													className={classNames(
														"form-control",
														"date-select",
														{
															"has-error": errors.PostExactDateTime,
														},
													)}
													type="date"
													min={minStartDate}
													value={PostExactDateTime}
													disabled={postAt !== "PostExactDateTime"}
													onChange={this.changeDate("PostExactDateTime")}
												/>
											</Otherwise>
										</Choose>
										<span>{lang.t("At")}</span>
										<TimeInput
											name="postExactTime"
											id="postExactTime"
											time={postExactTime}
											className={classNames("form-control", {
												"has-error": errors.postExactTime,
											})}
											min={minTime}
											disabled={
												postAt !== "PostExactDateTime" || !PostExactDateTime
											}
											handleChange={e => this.handleInputChange(e)}
											user={userData}
										/>
									</div>
								</If>
							</div>
						</div>
						<If
							condition={timeToPost === "specificDate" || timeToPost === "basedOnJob"}
						>
							<div className="separator separator-solid" />
						</If>

						{/* Officer Groups */}
						<div className="row">
							<div className="col-xs-12">
								<div
									className={classNames("form-group", {
										"has-error": errors.AssignmentGroupId,
									})}
								>
									<span>{lang.t("Viewing group (audience)")}</span>
									<ReactSelect
										options={officerGroups}
										name="PostedGroup"
										value={PostedGroup}
										onChange={e => this.handleInputChange(e, "PostedGroup")}
									/>
								</div>
							</div>
							<div className="col-xs-12">
								<If condition={PostedType === 2}>
									<div>
										<label htmlFor="OpenToAllOfficers">
											<input
												style={{ marginRight: "8px" }}
												type="checkbox"
												name="OpenToAllOfficers"
												id="OpenToAllOfficers"
												checked={OpenToAllOfficers}
												value={OpenToAllOfficers}
												onChange={e =>
													this.handleInputChange(e, "OpenToAllOfficers")
												}
												onClick={e =>
													this.handleInputChange(e, "OpenToAllOfficers")
												}
											/>
											{`${lang.t("Open to all officers")}`}
											<Tooltip
												content={`${lang.t("If this option is selected, you can post to a specific group then delay posting to the whole department with the two options below")}`}
											>
												<i className="rkf rkf-question-solid tooltip-icon hidden-xs" />
											</Tooltip>
										</label>
									</div>
									<If condition={OpenToAllOfficers}>
										<div style={{ marginLeft: "8px" }}>
											<div className="radio radio-align">
												<label htmlFor="PostedDelayType-variable">
													<input
														type="radio"
														name="PostedDelayType"
														id="PostedDelayType-variable"
														value={1}
														checked={PostedDelayType === 1}
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("After")}</span>
												</label>
											</div>
											<input
												type="tel"
												name="PostDelayInMinutes"
												className={classNames("form-control", {
													"has-error": errors.PostDelayInMinutes,
												})}
												placeholder="eg: 2"
												disabled={PostedDelayType !== 1}
												value={PostDelayInMinutes}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<span>{lang.t("Hours")}</span>
											<div className="radio">
												<label htmlFor="PostedDelayType-static">
													<input
														type="radio"
														name="PostedDelayType"
														id="PostedDelayType-static"
														value="2"
														checked={PostedDelayType === 2}
														onChange={e => this.handleRadioChange(e)}
													/>
													{lang.t("If not filled")}{" "}
													<strong>
														{lang.t("48 hours before job start_")}
													</strong>
												</label>
											</div>
										</div>
									</If>
								</If>
							</div>
						</div>
						{/* Officer Groups */}

						<If condition={PostedType === 2}>
							<div className="separator separator-solid" />
						</If>

						<div className="row">
							<div className="col-xs-12">
								<div
									className={classNames("form-group", {
										"has-error": errors.AssignmentGroupId,
									})}
								>
									<span>{lang.t("Assignment Type")}</span>
									<ReactSelect
										options={this.assignmentTypes}
										name="JobAutoAssignType"
										value={JobAutoAssignType}
										onChange={e =>
											this.handleInputChange(e, "JobAutoAssignType")
										}
									/>
								</div>
								<If condition={JobAutoAssignType === FIRST_COME_FIRST_SERVED}>
									<div className="indent">
										<div className="radio">
											<label htmlFor="noLimits">
												<input
													type="radio"
													name="fcfsAssignmentOption"
													id="noLimits"
													checked={fcfsAssignmentOption === 0}
													value={0}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("No Limits")}
												<Tooltip
													content={`${lang.t("Officers can apply for the job")}
													${lang.t("which will then be automatically assigned to the officer with the fewest number of hours_")}`}
												>
													<i className="rkf rkf-question-solid tooltip-icon hidden-xs" />
												</Tooltip>
											</label>
										</div>
										<div className="radio">
											<label htmlFor="limitJob">
												<input
													type="radio"
													name="fcfsAssignmentOption"
													id="limitJob"
													checked={fcfsAssignmentOption === 1}
													value={1}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("Limit # of Jobs")}
											</label>
										</div>
										<div className="indent">
											<For
												each="item"
												of={AutoAssignCycleLimits}
												index="index"
											>
												<div key={`job-limit_${item.id}`}>
													<Choose>
														<When condition={index === 0}>
															<span>
																{lang.t("Limit officer to")}
															</span>
														</When>
														<Otherwise>
															<span>{lang.t("Then limit")}</span>
														</Otherwise>
													</Choose>
													<input
														className={classNames("form-control", {
															"has-error": errors.CycleMaxAssignments,
														})}
														type="tel"
														placeholder="eg: 2"
														name="CycleMaxAssignments"
														value={
															AutoAssignCycleLimits[index]
																.CycleMaxAssignments
														}
														onChange={e =>
															this.handleJobLimitChange(e, index)
														}
														disabled={fcfsAssignmentOption !== 1}
													/>
													<Choose>
														<When condition={index === 0}>
															<span>{lang.t("job(s) for")}</span>
														</When>
														<Otherwise>
															<span>
																{lang.t("job(s) for the next")}
															</span>
														</Otherwise>
													</Choose>
													<input
														className={classNames("form-control", {
															"has-error": errors.CycleDaysSpan,
														})}
														type="tel"
														placeholder="eg: 2"
														name="CycleDaysSpan"
														value={
															AutoAssignCycleLimits[index]
																.CycleDaysSpan
														}
														onChange={e =>
															this.handleJobLimitChange(e, index)
														}
														disabled={fcfsAssignmentOption !== 1}
													/>
													<span>{lang.t("days")}</span>
													<Choose>
														<When
															condition={
																index ===
																AutoAssignCycleLimits.length - 1
															}
														>
															<button
																type="button"
																className="btn btn-link btn-primary"
																onClick={() => this.setJobLimits()}
																disabled={
																	fcfsAssignmentOption !== 1
																}
																aria-label="add job limit"
															>
																<i className="rkf rkf-plus-o" />
															</button>
														</When>
														<Otherwise>
															<button
																type="button"
																className="btn btn-link btn-danger"
																onClick={() =>
																	this.setJobLimits(item.id)
																}
																disabled={
																	fcfsAssignmentOption !== 1
																}
																aria-label="delete job limit"
															>
																<i className="rkf rkf-trash" />
															</button>
														</Otherwise>
													</Choose>
												</div>
											</For>
										</div>

										<div className="radio">
											<label htmlFor="signupLimit">
												<input
													type="radio"
													name="fcfsAssignmentOption"
													id="signupLimit"
													checked={fcfsAssignmentOption === 2}
													value={2}
													onChange={e => this.handleRadioChange(e)}
												/>
												{lang.t("With Sign Up Period")}
											</label>
										</div>
										<div className="indent">
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
												disabled={fcfsAssignmentOption !== 2}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
												disabled={fcfsAssignmentOption !== 2}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
											<div>
												{lang.t("With")}:
												<input
													className={classNames("form-control", {
														"has-error":
															errors.JobAutoAssignQueueCycleMaxAssignments,
													})}
													type="tel"
													placeholder="eg: 2"
													name="JobAutoAssignQueueCycleMaxAssignments"
													value={JobAutoAssignQueueCycleMaxAssignments}
													onChange={e => this.handleInputChange(e)}
													onBlur={e => this.handleIntegerOnBlur(e)}
													disabled={fcfsAssignmentOption !== 2}
												/>
												{lang.t("jobs per officer per round_")}
											</div>
											<div>
												<label htmlFor="assign-limit-to-rounds">
													<input
														type="checkbox"
														name="_limitToRoundsChecked"
														id="assign-limit-to-rounds"
														checked={_limitToRoundsChecked}
														value={_limitToRoundsChecked}
														disabled={fcfsAssignmentOption !== 2}
														onChange={e => this.handleInputChange(e)}
														onClick={e => this.handleInputChange(e)}
													/>
													{`${lang.t("Limit to")}:`}
												</label>
												<input
													type="tel"
													min="0"
													id="assign-hours-max-rounds"
													name="NumberOfRounds"
													className={classNames("form-control", {
														"has-error": errors.NumberOfRounds,
													})}
													placeholder="eg: 2"
													disabled={!_limitToRoundsChecked}
													value={NumberOfRounds}
													onChange={e => this.handleInputChange(e)}
												/>
												{lang.t("max rounds")}
											</div>
										</div>
									</div>
								</If>
								<If condition={JobAutoAssignType === BY_HOURS}>
									<div className="indent">
										<span>{lang.t("Sign-Up Period")}:</span>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignHoursSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignHoursSpan"
											value={JobAutoAssignHoursSpan}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<select
											name="signUpPeriodHoursMultiplier"
											className="form-control"
											placeholder={lang.t("Hours or days_")}
											value={signUpPeriodHoursMultiplier}
											onChange={e => this.handleInputChange(e)}
										>
											<For
												each="item"
												of={this.signUpPeriodTimeTypeOptions}
												index="index"
											>
												<option
													key={`signUpPeriod_${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
										<div>{lang.t("Time to Consider")}:</div>
										<div className="radio radio-align">
											<label htmlFor="JobAutoAssignYearToDateSpan-byHours">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignJobCountDaysRadio-byHours"
													checked={JobAutoAssignJobCountDaysRadio}
													value="false"
													onChange={e => this.handleRadioChange(e)}
												/>
											</label>
										</div>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignJobCountDaysSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignJobCountDaysSpan"
											value={JobAutoAssignJobCountDaysSpan}
											disabled={!JobAutoAssignJobCountDaysRadio}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<span>{lang.t("days")}</span>
										<div className="radio">
											<label htmlFor="JobAutoAssignYearToDateSpan-toDate">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignYearToDateSpan-toDate"
													checked={JobAutoAssignYearToDateSpan}
													value="true"
													onChange={e => this.handleRadioChange(e)}
												/>
												<span>{lang.t("Year to Date")}</span>
											</label>
										</div>
										<div className="radio">
											<label htmlFor="JobAutoAssignRolling365-toDate">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignRolling365-toDate"
													checked={JobAutoAssignRolling365}
													value="true"
													onChange={e => this.handleRadioChange(e)}
												/>
												<span>{lang.t("Rolling 365")}</span>
											</label>
										</div>
										<If condition={this.isHolyokeOrg}>
											<div className="radio">
												<label htmlFor="JobAssignmentBiAnnually-biAnnually">
													<input
														type="radio"
														name="JobAutoAssignYearToDateSpan"
														id="JobAssignmentBiAnnually-biAnnually"
														checked={JobAssignmentBiAnnually}
														value="true"
														onChange={e => this.handleRadioChange(e)}
													/>
													<span>{lang.t("Bi-Annually")}</span>
												</label>
											</div>
											<div className="checkbox">
												<label htmlFor="OnlyCountHoursForJobsPostedWithThisRule">
													<input
														type="checkbox"
														name="OnlyCountHoursForJobsPostedWithThisRule"
														id="OnlyCountHoursForJobsPostedWithThisRule"
														checked={
															OnlyCountHoursForJobsPostedWithThisRule
														}
														value="true"
														onChange={e => this.handleInputChange(e)}
														onClick={e => this.handleInputChange(e)}
													/>
													<span>
														{lang.t(
															"Only count hours for jobs posted with this rule",
														)}
													</span>
												</label>
											</div>
										</If>
									</div>
								</If>
								<If condition={JobAutoAssignType === BY_JOBS}>
									<div className="indent">
										<span>{lang.t("Sign-Up Period")}:</span>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignHoursSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignHoursSpan"
											value={JobAutoAssignHoursSpan}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<select
											name="signUpPeriodHoursMultiplier"
											className="form-control"
											placeholder={lang.t("Hours or days_")}
											value={signUpPeriodHoursMultiplier}
											onChange={e => this.handleInputChange(e)}
										>
											<For
												each="item"
												of={this.signUpPeriodTimeTypeOptions}
												index="index"
											>
												<option
													key={`signUpPeriod_${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
										<div>{lang.t("Time to Consider")}:</div>
										<div className="radio radio-align">
											<label htmlFor="JobAutoAssignYearToDateSpan-byHours">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignJobCountDaysRadio-byHours"
													checked={JobAutoAssignJobCountDaysRadio}
													value="false"
													onChange={e => this.handleRadioChange(e)}
												/>
											</label>
										</div>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignJobCountDaysSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignJobCountDaysSpan"
											value={JobAutoAssignJobCountDaysSpan}
											disabled={!JobAutoAssignJobCountDaysRadio}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<span>{lang.t("days")}</span>
										<div className="radio">
											<label htmlFor="JobAutoAssignYearToDateSpan-toDate">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignYearToDateSpan-toDate"
													checked={JobAutoAssignYearToDateSpan}
													value="true"
													onChange={e => this.handleRadioChange(e)}
												/>
												<span>{lang.t("Year to Date")}</span>
											</label>
										</div>
										<div className="radio">
											<label htmlFor="JobAutoAssignRolling365-toDate">
												<input
													type="radio"
													name="JobAutoAssignYearToDateSpan"
													id="JobAutoAssignRolling365-toDate"
													checked={JobAutoAssignRolling365}
													value="true"
													onChange={e => this.handleRadioChange(e)}
												/>
												<span>{lang.t("Rolling 365")}</span>
											</label>
										</div>
									</div>
								</If>
								<If condition={JobAutoAssignType === SENIORITY_DESCENDING}>
									<div className="indent">
										<span>{lang.t("Sign-Up Period")}:</span>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignHoursSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignHoursSpan"
											value={JobAutoAssignHoursSpan}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<select
											name="signUpPeriodHoursMultiplier"
											className="form-control"
											placeholder={lang.t("Hours or days_")}
											value={signUpPeriodHoursMultiplier}
											onChange={e => this.handleInputChange(e)}
										>
											<For
												each="item"
												of={this.signUpPeriodTimeTypeOptions}
												index="index"
											>
												<option
													key={`signUpPeriod_${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
										<div>
											{lang.t("With")}:
											<input
												className={classNames("form-control", {
													"has-error":
														errors.JobAutoAssignQueueCycleMaxAssignments,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignQueueCycleMaxAssignments"
												value={JobAutoAssignQueueCycleMaxAssignments}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											{lang.t("jobs per officer per round_")}
										</div>
										<div>
											<label htmlFor="assign-limit-to-rounds">
												<input
													type="checkbox"
													name="_limitToRoundsChecked"
													id="assign-limit-to-rounds"
													checked={_limitToRoundsChecked}
													value={_limitToRoundsChecked}
													onChange={e => this.handleInputChange(e)}
													onClick={e => this.handleInputChange(e)}
												/>
												{`${lang.t("Limit to")}:`}
											</label>
											<input
												type="tel"
												min="0"
												id="assign-hours-max-rounds"
												name="NumberOfRounds"
												className={classNames("form-control", {
													"has-error": errors.NumberOfRounds,
												})}
												placeholder="eg: 2"
												disabled={!_limitToRoundsChecked}
												value={NumberOfRounds}
												onChange={e => this.handleInputChange(e)}
											/>
											{lang.t("max rounds")}
										</div>
									</div>
								</If>
								<If condition={JobAutoAssignType === SENIORITY_ASCENDING}>
									<div className="indent">
										<span>{lang.t("Sign-Up Period")}:</span>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignHoursSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignHoursSpan"
											value={JobAutoAssignHoursSpan}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<select
											name="signUpPeriodHoursMultiplier"
											className="form-control"
											placeholder={lang.t("Hours or days_")}
											value={signUpPeriodHoursMultiplier}
											onChange={e => this.handleInputChange(e)}
										>
											<For
												each="item"
												of={this.signUpPeriodTimeTypeOptions}
												index="index"
											>
												<option
													key={`signUpPeriod_${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
										<div>
											{lang.t("With")}:
											<input
												className={classNames("form-control", {
													"has-error":
														errors.JobAutoAssignQueueCycleMaxAssignments,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignQueueCycleMaxAssignments"
												value={JobAutoAssignQueueCycleMaxAssignments}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											{lang.t("jobs per officer per round_")}
										</div>
										<div>
											<label htmlFor="assign-limit-to-rounds">
												<input
													type="checkbox"
													name="_limitToRoundsChecked"
													id="assign-limit-to-rounds"
													checked={_limitToRoundsChecked}
													value={_limitToRoundsChecked}
													onChange={e => this.handleInputChange(e)}
													onClick={e => this.handleInputChange(e)}
												/>
												{`${lang.t("Limit to")}:`}
											</label>
											<input
												type="tel"
												min="0"
												id="assign-hours-max-rounds"
												name="NumberOfRounds"
												className={classNames("form-control", {
													"has-error": errors.NumberOfRounds,
												})}
												placeholder="eg: 2"
												disabled={!_limitToRoundsChecked}
												value={NumberOfRounds}
												onChange={e => this.handleInputChange(e)}
											/>
											{lang.t("max rounds")}
										</div>
									</div>
								</If>
								{/* TODO: remove utils.isOrganizationEnabled(organization.Id) when the seniority draft will be released to all departments */}
								<If condition={JobAutoAssignType === SENIORITY_DRAFT}>
									<div className="indent">
										<div>
											<span>{`${lang.t("Sort by")}:`}</span>
											<select
												id="seniority-order"
												name="SeniorityOrder"
												className="form-control"
												value={SeniorityOrder}
												onChange={e => this.handleInputChange(e)}
											>
												<option value={MOST_SENIOR}>
													{lang.t("Most senior")}
												</option>
												<option value={LEAST_SENIOR}>
													{lang.t("Least senior")}
												</option>
											</select>
										</div>
										<div>
											<span>{lang.t("Sign-Up Period")}:</span>
											<input
												className={classNames("form-control", {
													"has-error": errors.JobAutoAssignHoursSpan,
												})}
												type="tel"
												placeholder="eg: 2"
												name="JobAutoAssignHoursSpan"
												value={JobAutoAssignHoursSpan}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												name="signUpPeriodHoursMultiplier"
												className="form-control"
												placeholder={lang.t("Hours or days_")}
												value={signUpPeriodHoursMultiplier}
												onChange={e => this.handleInputChange(e)}
											>
												<For
													each="item"
													of={this.signUpPeriodTimeTypeOptions}
													index="index"
												>
													<option
														key={`signUpPeriod_${index}_${item.value}`}
														value={item.value}
													>
														{item.label}
													</option>
												</For>
											</select>
										</div>
										<div>
											{lang.t("With")}:
											<input
												className={classNames("form-control", {
													"has-error":
														errors._hoursJobsSelectedOptionValue,
												})}
												type="tel"
												placeholder="eg: 2"
												name="_hoursJobsSelectedOptionValue"
												value={_hoursJobsSelectedOptionValue}
												onChange={e => this.handleInputChange(e)}
												onBlur={e => this.handleIntegerOnBlur(e)}
											/>
											<select
												id="assign-hours-multiplier"
												name="_hoursJobsSelectedOption"
												className="form-control"
												value={_hoursJobsSelectedOption}
												onChange={e => this.handleInputChange(e)}
											>
												<option value="MaxHoursAssignmentPerCycle">
													{lang.t("Hours")}
												</option>
												<option value="JobAutoAssignQueueCycleMaxAssignments">
													{lang.t("Jobs")}
												</option>
											</select>
											{lang.t("per officer per round")}
										</div>
										<div>
											<label htmlFor="assign-limit-to-rounds">
												<input
													type="checkbox"
													name="_limitToRoundsChecked"
													id="assign-limit-to-rounds"
													checked={_limitToRoundsChecked}
													value={_limitToRoundsChecked}
													onChange={e => this.handleInputChange(e)}
													onClick={e => this.handleInputChange(e)}
												/>
												{`${lang.t("Limit to")}:`}
											</label>
											<input
												type="tel"
												min="0"
												id="assign-hours-max-rounds"
												name="NumberOfRounds"
												className={classNames("form-control", {
													"has-error": errors.NumberOfRounds,
												})}
												placeholder="eg: 2"
												disabled={!_limitToRoundsChecked}
												value={NumberOfRounds}
												onChange={e => this.handleInputChange(e)}
											/>
											{lang.t("max rounds")}
										</div>
									</div>
								</If>
								<If condition={JobAutoAssignType === RANDOM}>
									<div className="indent">
										<span>{lang.t("Sign-Up Period")}:</span>
										<input
											className={classNames("form-control", {
												"has-error": errors.JobAutoAssignHoursSpan,
											})}
											type="tel"
											placeholder="eg: 2"
											name="JobAutoAssignHoursSpan"
											value={JobAutoAssignHoursSpan}
											onChange={e => this.handleInputChange(e)}
											onBlur={e => this.handleIntegerOnBlur(e)}
										/>
										<select
											name="signUpPeriodHoursMultiplier"
											className="form-control"
											placeholder={lang.t("Hours or days_")}
											value={signUpPeriodHoursMultiplier}
											onChange={e => this.handleInputChange(e)}
										>
											<For
												each="item"
												of={this.signUpPeriodTimeTypeOptions}
												index="index"
											>
												<option
													key={`signUpPeriod_${index}_${item.value}`}
													value={item.value}
												>
													{item.label}
												</option>
											</For>
										</select>
									</div>
								</If>
							</div>
						</div>

						<If
							condition={
								(JobAutoAssignType !== MANUAL &&
									JobAutoAssignType !== FIRST_COME_FIRST_SERVED) ||
								(JobAutoAssignType === FIRST_COME_FIRST_SERVED &&
									(fcfsAssignmentOption === 2 || fcfsAssignmentOption === 1))
							}
						>
							<div className="separator separator-solid" />
							<div className="row">
								<div className="col-xs-12">
									<label
										htmlFor="enable-fist-come-first-served"
										className="fcfs-label"
									>
										<input
											style={{ marginRight: "8px" }}
											type="checkbox"
											name="EnableFirstComeFirstServed"
											id="enable-fist-come-first-served"
											checked={EnableFirstComeFirstServed}
											value={EnableFirstComeFirstServed}
											onChange={e => this.handleInputChange(e)}
											onClick={e => this.handleInputChange(e)}
										/>
										{`${lang.t("After sign up period has expired, post job as First come first serve to whole department")}`}
										<Tooltip
											content={`${lang.t("If this option is not selected the job will unpost at the end of the sign up period, which may affect call off options_")},
										 ${lang.t("If you would like to post First come first serve to a specific group, try building a staggered rule set_")}`}
										>
											<i className="rkf rkf-question-solid tooltip-icon hidden-xs" />
										</Tooltip>
									</label>
								</div>
							</div>
						</If>
						{/* Officer Approval & Assignment Rules */}
					</Modal.Body>
					<Modal.Footer>
						<button
							id="btn-close-modal"
							className="btn btn-link"
							type="button"
							onClick={() => this.closeModal()}
						>
							{lang.t("Close")}
						</button>
						<button
							id="btn-post-job"
							className="btn btn-primary"
							type="button"
							onClick={() => this.onSaveAssigmentRule()}
						>
							{lang.t("Save")}
						</button>
					</Modal.Footer>
				</Modal>
				<ConfirmationModal ref={this._confirmationModal} />
			</Fragment>
		);
	}
}

AssignmentRulesModal.propTypes = {
	show: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired,
	assignmentRuleId: PropTypes.number,
	successCallback: PropTypes.func,
	officerGroups: PropTypes.array,
	userData: PropTypes.object, // TODO: remove this when the seniority draft is no longer needed for Adventure PD only
};

AssignmentRulesModal.defaultProps = {
	assignmentRuleId: null,
	successCallback: () => {},
	officerGroups: [],
	userData: { Organization: { Id: 0 } }, // TODO: remove this when the seniority draft is no longer needed for Adventure PD only
};

export default AssignmentRulesModal;
